import instance from '@/api/index.js'
const urlPrefix = '/v1/project'
export default {
  getProjects (params){
    return instance({
      method: 'get',
      params: params,
      url: `${urlPrefix}/list`,
    })
  },
  getKanban(params) {
    return instance({
      method: 'get',
      params: params,
      url: `${urlPrefix}/kanban`,
    })
  },

  createProject (data){
    return instance(
      {
        method: 'post',
        url:`${urlPrefix}`,
        data: data,
      }
    )
  },
  delProject(param) {
    return instance(
      {
        method: 'delete',
        params: param,
        url:`${urlPrefix}`,
      })
  },
  getProjectDetail(id) {
    return instance(
      {
        method: 'get',
        params: {
          id: id,
        },
        url:`${urlPrefix}/detail`,

      }
    )
  },
  // 编辑需求
  editProject(id, data) {
    return instance(
      {
        method: 'patch',
        params: id,
        data : data,
        url:`${urlPrefix}`,
      })
  },
  editProjectKanban(id, data) {
    return instance(
      {
        method: 'put',
        params: id,
        data : data,
        url:`${urlPrefix}`,
      }
    )
  },
  getProductSummary() {
    return instance(
      {
        method: 'get',
        url:`${urlPrefix}/product_summary`,
      }
    )
  },
  getPmSummary() {
    return instance(
      {
        method: 'get',
        url:`${urlPrefix}/pm_summary`,

      }
    )
  },
  getDueDateSummary() {
    return instance(
      {
        method: 'get',
        url:`${urlPrefix}/date_summary`,

      }
    )
  },



}
